<template>
  <div class="logo-outline">
    <h2 class="hadyna text-center">
      HADYNA
    </h2>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: String
  }
}
</script>

<style scoped>

@keyframes changeColor {
  0% {
    background-color: darkgrey;
  }

  50% {
    background-color: rgb(88, 88, 88);
  }

  100% {
    background-color: darkgrey;
  }
}

.logo-outline {
  /* letter-spacing: -4px; */
  position: absolute!important;
  background-color: darkgrey;
  border: 3px solid outset;
  top: 25px;
  left: 50%;
  margin-left: -125px;
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
   -khtml-user-select: none; /* Konqueror HTML */
     -moz-user-select: none; /* Old versions of Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently
                                supported by Chrome, Opera and Firefox */
}
.logo-outline:hover {
  animation: changeColor 3s ease infinite;
}
.hadyna {
  margin-top: 10px;
  font-weight: bold;
  border: 1px solid black;
  font-family: 'DM Serif Display', serif!important;
  padding: 12px 10px 15px!important;
  width: 100%;
  background-color: white;
  margin-left: -10px;
  line-height: 20px;
  font-size: 3.75rem!important;
}

</style>
